import { render, staticRenderFns } from "./sourceAnalysis.vue?vue&type=template&id=5c20758f&"
import script from "./sourceAnalysis.vue?vue&type=script&lang=js&"
export * from "./sourceAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./sourceAnalysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports